module.exports = __webpack_public_path__ + "static/media/CheckmarkCircle.582da5cd.svg";